import React, { useState } from 'react';
import styled from 'styled-components';
import AddNote from '../../../../assets/icons/add-note.svg';
import { NotesModal } from '@/components';

export const Notes = ({ notes, questionTitle, questionId, refetchQuest }) => {
  const [isAddNoteModalOpen, setIsAddNoteModalOpen] = useState(false);

  return (
    <>
      <NotesButton onClick={() => setIsAddNoteModalOpen(true)}>
        <NotesImg src={AddNote} />
        {notes && notes.length > 0 && (
          <NotesCount>
            <span>{notes.length}</span>
          </NotesCount>
        )}
      </NotesButton>

      <NotesModal
        questionTitle={questionTitle}
        questionId={questionId}
        notes={notes}
        active={isAddNoteModalOpen}
        onClose={() => setIsAddNoteModalOpen(false)}
        refetchQuest={refetchQuest}
      />
    </>
  );
};

const NotesButton = styled.button`
  position: relative;
  border: 0;
  width: 28px;
  height: 28px;
  margin-top: 6px;
  padding: 0;
  background: transparent;
  cursor: pointer;

  &:hover {
    opacity: 0.7;
  }
`;

const NotesCount = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 8px;
  line-height: 8px;
  color: white;
  bottom: 0;
  left: 0;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #ff6969;
`;

const NotesImg = styled.img`
  width: 28px;
  height: 28px;
`;
